import { render } from "./HandbookBalance.vue?vue&type=template&id=4e056072&scoped=true"
import script from "./HandbookBalance.vue?vue&type=script&lang=js"
export * from "./HandbookBalance.vue?vue&type=script&lang=js"

import "./HandbookBalance.vue?vue&type=style&index=0&id=4e056072&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e056072"]])

export default __exports__